export default __webpack_public_path__ + "static/media/Menu.b930f1ec.svg";